import { Routes } from '@angular/router';

import { LAZY_FEATURE_ROUTES } from './features/feature-routes';
import { authChildGuard, authGuard } from './guards/auth.guard';
import { AppLayoutComponent } from './layouts/app-layout/app-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';

export const appRoutes: Routes = [
  {
    path: 'login',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/auth/pages/login/login.component').then(m => m.LoginComponent)
      }
    ]
  },
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [authGuard],
    canActivateChild: [authChildGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard'
      },
      ...LAZY_FEATURE_ROUTES
    ]
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];
